import { InputGroup, Spinner, SpinnerSize } from "@blueprintjs/core";
import { Classes } from "@blueprintjs/popover2";
import React, { useState } from "react";

import { Button } from "../../../components/Button/button";
import styles from "./play-name-popover.module.scss";

export interface PlayNamePopoverProps {
  onSave: (name: string) => void;
  onContinue: () => void;
  isSaving: boolean;
}

const PlayNamePopover = ({ onSave, onContinue, isSaving }: PlayNamePopoverProps) => {
  const [name, setName] = useState<string>("");

  const handleOnSaveClick = () => {
    onSave(name);
  };

  return (
    <div className={styles.popover}>
      <div className={styles.popoverHeader}>Give your play a name?</div>
      <div className={styles.inputContainer}>
        <InputGroup
          placeholder="Untitled"
          leftIcon="edit"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={styles.input}
        />
      </div>
      <div className={styles.centerFlex}>
        <div className={styles.popoverButtonContainer}>
          <Button
            minimal={true}
            className={styles.primaryButton}
            text="Later"
            onClick={onContinue}
            disabled={isSaving}
          />
          <Button
            intent="primary"
            className={`${Classes.POPOVER2_DISMISS} ml-1`}
            onClick={handleOnSaveClick}
            disabled={name === "" || isSaving}
          >
            {isSaving ? <Spinner size={SpinnerSize.SMALL} /> : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PlayNamePopover;
